import { render, staticRenderFns } from "./ivstplan.vue?vue&type=template&id=3a52b7aa"
import script from "./ivstplan.vue?vue&type=script&lang=js"
export * from "./ivstplan.vue?vue&type=script&lang=js"
import style0 from "./ivstplan.vue?vue&type=style&index=0&id=3a52b7aa&prod&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports